import { Injectable } from '@angular/core';

import ticketAPIConfig from 'src/app/modules/apps/new-ticketing-dashboard/new-ticketing-dashboard-api.config.json';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class ChartService {
  constructor(private apiService: ApiService) {}

  public getConsolidatedAgeingList() {
    return this.apiService.get(ticketAPIConfig.getConsolidatedAgeingList);
  }

  public getAgeingList() {
    return this.apiService.get(ticketAPIConfig.getAgeingList);
  }

  public getIncidentSuccessbyCapabitlity() {
    return this.apiService.post(ticketAPIConfig.getIncidentSuccessbyCapabitlity, {});
  }

  public getIncidentFailurebyCapabitlity() {
    return this.apiService.post(ticketAPIConfig.getIncidentFailCountPerSolutionByCapability, {});
  }

  public getIncidentSuccessbyCatalog() {
    return this.apiService.post(ticketAPIConfig.getIncidentSuccessCountPerSolutionByCatalogue, {});
  }

  public getIncidentSuccessbyTechnology() {
    return this.apiService.post(ticketAPIConfig.getIncidentSucessCountPerSolutionByTechnology, {});
  }

  public getCatalogDistributonBots() {
    return this.apiService.post(ticketAPIConfig.getCatalogueDistributionOfBots, {});
  }

  public getCapabilityDistributonBots() {
    return this.apiService.post(ticketAPIConfig.getCapabilityDistributionOfBots, {});
  }

  public getTechnologyDistributonBots() {
    return this.apiService.post(ticketAPIConfig.getTechnologyDistributionOfBots, {});
  }
}
